module.exports = __webpack_public_path__ + "eti-gumus-logo.d4fdca3937413091eb6b.svg";


//////////////////
// WEBPACK FOOTER
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/assets/img/eti-gumus-logo.svg
// module id = ../../../../../src/assets/img/eti-gumus-logo.svg
// module chunks = main